import Nav from "react-bootstrap/Nav";
import Tab from "react-bootstrap/Tab";
import Common_Banner from "../common-components/common-banner/Common_Banner";
import "./Sports_program.css";
import Group_fitness from "./group_fitness_for_adults/Group_fitness";
import Kids_athletics from "./kids_athletics/Kids_athletics";
import Kids_fitness from "./kids_fitness/Kids_fitness";
import Marathon from "./marathon/Marathon";
import Personal_training from "./personal_training/Personal_training";

const Sports_program = () => {
  const breadcrumbs = [
    { label: "Home", link: "/", isActive: false },
    { label: "Sports Programs", link: "", isActive: true },
  ];
  return (
    <>
      <Common_Banner
        imgSrc={"/assets/images/common_banners/blogs_banner.png"}
        title_text="Sports Programs"
        breadcrumbs={breadcrumbs}
      />
      <div className="about_bg_img_holder">
        <div className="container">
          <div className="sports_program_tab_div">
            <Tab.Container
              id="left-tabs-example"
              defaultActiveKey="Kids-fitness"
            >
              <Nav variant="" className="d-flex">
                <Nav.Item>
                  <Nav.Link eventKey="Kids-fitness">Kids Fitness</Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link eventKey="Kids_athletics">Kids Athletics</Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link eventKey="Group-fitness">
                    Group fitness for Adults
                  </Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link eventKey="Personal_training">
                    Personal Training
                  </Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link eventKey="Marathon">Marathon Training</Nav.Link>
                </Nav.Item>
              </Nav>

              <hr className="divider" />

              <Tab.Content>
                <Tab.Pane eventKey="Kids-fitness">
                  <Kids_fitness />
                </Tab.Pane>

                <Tab.Pane eventKey="Kids_athletics">
                  <Kids_athletics />
                </Tab.Pane>

                <Tab.Pane eventKey="Group-fitness">
                  <Group_fitness />
                </Tab.Pane>

                <Tab.Pane eventKey="Personal_training">
                  <Personal_training />
                </Tab.Pane>

                <Tab.Pane eventKey="Marathon">
                  <Marathon />
                </Tab.Pane>
              </Tab.Content>
            </Tab.Container>
          </div>
        </div>
      </div>
    </>
  );
};

export default Sports_program;
